import * as React from 'react'

export default function TableHead({ children }: React.PropsWithChildren<{}>) {
  return <thead>{children}</thead>
}
